import { render } from "./TheHeaderMobile.vue?vue&type=template&id=1913c8ce"
import script from "./TheHeaderMobile.vue?vue&type=script&lang=js"
export * from "./TheHeaderMobile.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__